import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { ProductScopeLayout } from './components/ProductScopeLayout';
import { RoleRoute } from './components/RoleRoute';
import { GuestRoute, ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { useOperatorPermissions } from './hooks/useOperatorPermissions';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { ModelsPage } from './pages/ModelsPage';
import { ModelStudioEditorPage } from './pages/ModelStudioEditorPage';
import { PlansPage } from './pages/PlansPage';
import { StudioWorkspacesPage } from './pages/StudioWorkspacesPage';
import { UsageAnalyticsPage } from './pages/UsageAnalyticsPage';
import { UsersPage } from './pages/UsersPage';
import { StudioUserDetailPage } from './pages/StudioUserDetailPage';
import { EconomicsPage } from './pages/EconomicsPage';

function StudioRoutes() {
  const perms = useOperatorPermissions();

  return (
    <Routes>
      <Route
        path="/login"
        element={
          <GuestRoute>
            <LoginPage />
          </GuestRoute>
        }
      />
      <Route
        element={
          <ProtectedRoute>
            <AppLayout product="studio" />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/studio" replace />} />
        <Route path="studio" element={<ProductScopeLayout scope="studio" />}>
          <Route index element={<DashboardPage />} />
          <Route path="workspaces" element={<StudioWorkspacesPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<StudioUserDetailPage />} />
          <Route path="plans" element={<PlansPage />} />
          <Route
            path="economics"
            element={
              <RoleRoute allowed={perms.canViewBilling}>
                <EconomicsPage product="STUDIO" />
              </RoleRoute>
            }
          />
          <Route
            path="models"
            element={
              <RoleRoute allowed={perms.canViewModels}>
                <ModelsPage product="studio" />
              </RoleRoute>
            }
          />
          <Route
            path="models/:id/edit"
            element={
              <RoleRoute allowed={perms.canViewModels}>
                <ModelStudioEditorPage />
              </RoleRoute>
            }
          />
          <Route
            path="usage"
            element={
              <RoleRoute allowed={perms.canViewUsage}>
                <UsageAnalyticsPage />
              </RoleRoute>
            }
          />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/studio" replace />} />
    </Routes>
  );
}

export default function AppStudio() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <StudioRoutes />
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}
